import localStorage from "helpers/localStorage";
import { logoutUser } from "../slices/authSlice";
import { useDispatch } from "react-redux";
import history from "config/history";

function AuthVerify() {
  const handleLogout = () => {
    dispatch(logoutUser());
    history.push("/");
  };
  const dispatch = useDispatch();
  const expiryDate = new Date(localStorage.getItem("expiryDate")?.replace('Z',''));
  if (expiryDate <new Date()) {
    handleLogout();
  }
  return null;
}
export default AuthVerify;
